import React from 'react';
import PropTypes from 'prop-types';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const Burger = props => (
  <button className="burgerMenu" onClick={props.onClick}>
    <FontAwesomeIcon icon={['fas', 'bars']} />
  </button>
);

export default Burger;

Burger.propTypes = {
  onClick: PropTypes.func,
};

Burger.defaultProps = {
  onClick: () => {
    this.setState(prevState => ({
      burgerToggle: !prevState.burgerToggle,
    }));
  },
};
